import { render, staticRenderFns } from "./category-last.vue?vue&type=template&id=7462e9f2"
import script from "./category-last.vue?vue&type=script&lang=js"
export * from "./category-last.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports